module.exports = __webpack_public_path__ + "img/icon_deng_pao.f23271b5.svg";